import { getProjectSpaceKey } from '../../state/confluence/connected-space/selectors';
import { type ActivationState, type ActivationStatus, type ActivationMethod } from './types';
import { type State } from '../types';
import { getTemplatesToShow } from '../ui/blueprints/selectors';
import { TEMPLATES_REAL_LIST } from '../ui/blueprints/types';

export const getActivationState = (state: State): ActivationState => state.activation;

export const getActivationStatus = (state: State): ActivationStatus =>
	getActivationState(state).status;

export const getActivationMethod = (state: State): ActivationMethod => {
	switch (getActivationStatus(state)) {
		case 'activating':
		case 'allowed':
			return 'integrated';
		case 'not-started':
			return 'loading';
		case 'completed':
		case 'error':
		case 'not-allowed':
		default:
			return 'modal';
	}
};
export const isActivationMethodDetermined = (state: State): boolean =>
	getActivationMethod(state) !== 'loading';

export const activationStatusRetryCount = (state: State): number =>
	getActivationState(state).retryCount;

export const getUserInitiatedActivation = (state: State): boolean => state.activation.userInitiated;

export const isConfluenceActivationCompleteForPreselectedTemplate = (state: State): boolean => {
	const status = getActivationStatus(state);
	const userInitiated = getUserInitiatedActivation(state);
	const spaceKey = getProjectSpaceKey(state);
	const templatesToShow = getTemplatesToShow(state);

	return (
		status === 'completed' &&
		userInitiated &&
		spaceKey !== null &&
		templatesToShow === TEMPLATES_REAL_LIST
	);
};
